import { ReactComponent as ProgressBarStatIcon } from 'assets/icons/a11ymenu_statbar.svg';
import { ReactComponent as DonutStatIcon } from 'assets/icons/a11ymenu_statdonut.svg';
import { ReactComponent as HalfDonutStatIcon } from 'assets/icons/a11ymenu_stathalfdonut.svg';
import { ReactComponent as IconStatIcon } from 'assets/icons/a11ymenu_staticon.svg';

import { StatChartType } from '../../StatChartWidget.types';

export const CHART_SWAP_OPTIONS = [
  {
    value: StatChartType.Donut,
    label: 'DonutStat',
    icon: <DonutStatIcon width='15' />,
  },
  {
    value: StatChartType.HalfDonut,
    label: 'HalfDonutStat',
    icon: <HalfDonutStatIcon width='15' />,
  },
  {
    value: StatChartType.ProgressBar,
    label: 'ProgressBarStat',
    icon: <ProgressBarStatIcon width='15' />,
  },
  {
    value: StatChartType.Icon,
    label: 'IconStat',
    icon: <IconStatIcon width='15' />,
  },
];

export const CHART_SWAP_OPTIONS_NO_LABEL = [
  {
    value: StatChartType.Donut,
    label: 'Donut',
    icon: <DonutStatIcon width='15' />,
  },
  {
    value: StatChartType.HalfDonut,
    label: 'HalfDonut',
    icon: <HalfDonutStatIcon width='15' />,
  },
  {
    value: StatChartType.ProgressBar,
    label: 'ProgressBar',
    icon: <ProgressBarStatIcon width='15' />,
  },
  {
    value: StatChartType.Icon,
    label: 'Icon',
    icon: <IconStatIcon width='15' />,
  },
];
